import React, { useState, useEffect } from 'react';
import '../styles/editModal.css';
import '../styles/leagueManagement.css';

// Поля championats, которые заводит админ.
// client_id подставляет бэкенд из токена — админу его не показываем.
export default function CreateChampionatModal({ isOpen, onClose, onCreate, existingNames }) {
    const [name, setName] = useState('');
    const [priority, setPriority] = useState('1');
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!isOpen) return;
        setName('');
        setPriority('1');
        setError(null);
    }, [isOpen]);

    if (!isOpen) return null;

    const parsedPriority = parseInt(priority, 10);

    const submit = () => {
        const trimmed = name.trim();
        if (!trimmed) {
            setError('Введите название чемпионата.');
            return;
        }
        if (existingNames.includes(trimmed)) {
            setError('Чемпионат с таким названием уже есть.');
            return;
        }
        if (isNaN(parsedPriority) || parsedPriority < 0) {
            setError('Приоритет должен быть целым числом от 0.');
            return;
        }
        onCreate({ name: trimmed, priority: parsedPriority });
        onClose();
    };

    return (
        <div className="modalOverlay" onClick={onClose}>
            <div className="modalContent modalContentWide" onClick={(e) => e.stopPropagation()}>
                <div className="modalHeader">
                    <h2>Новый чемпионат</h2>
                    <button className="modalClose" onClick={onClose}>×</button>
                </div>
                <div className="modalBody">
                    <div className="lmRow">
                        <label className="modalLabel">Название чемпионата</label>
                        <input
                            type="text"
                            className="modalInput"
                            maxLength={100}
                            value={name}
                            placeholder="например «Анапа. 12-15 ноября»"
                            autoFocus
                            onChange={(e) => setName(e.target.value)}
                            onKeyDown={(e) => { if (e.key === 'Enter') submit(); }}
                        />
                    </div>

                    <div className="lmRow">
                        <label className="modalLabel">Приоритет</label>
                        <input
                            type="number"
                            className="modalInput inputNarrow"
                            min={0}
                            value={priority}
                            onChange={(e) => setPriority(e.target.value)}
                            onKeyDown={(e) => { if (e.key === 'Enter') submit(); }}
                        />
                        <span className="fieldHint">
                            Чем меньше число, тем выше чемпионат в списке.
                        </span>
                    </div>

                    {error && <span className="fieldError">{error}</span>}
                </div>
                <div className="modalFooter">
                    <button className="modalButton modalButtonCancel" onClick={onClose}>
                        Отмена
                    </button>
                    <button className="modalButton modalButtonSave" onClick={submit}>
                        Создать чемпионат
                    </button>
                </div>
            </div>
        </div>
    );
}
